// 岗位职责管理
<template>
  <div class="response-manage atb-flex atb-flex-column">
    <div class="atb-content-bg atb-flex atb-flex-column">
      <div class="search">
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
            <el-popover placement="bottom-start" width="420" popper-class="popper-tree declare-dep" @hide="handledHide" trigger="click">
              <el-tree
                :props="defaultProps"
                :data="treeData"
                show-checkbox
                node-key="id"
                ref="tree"
                highlight-current
                :default-expanded-keys="expandedData"
                @check-change="handleCheckChange"
              >
              </el-tree>
              <el-input slot="reference" v-model="department" placeholder="请选择部门名称" clearable></el-input>
            </el-popover>
          </el-form-item>
          <el-form-item label="上级">
            <selecter v-model="searchParam.superiorNo" placeholder="输入工号或姓名查询"></selecter>
          </el-form-item>
          <el-form-item label="姓名">
            <selecter v-model="searchParam.reWkNo"></selecter>
          </el-form-item>
          <el-form-item label="年份">
            <el-date-picker v-model="searchParam.year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
          </el-form-item>
          <el-form-item label="状态">
            <common-select ref="status" v-model="searchParam.status" :list="statusList" optLabel="itemDesc" optValue="itemValue" placeholder="状态" clearable></common-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="add" style="width: 90px!important;"  @click="showNotJoin">不参与维护</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="downloadTemplate" style="width: 110px!important;"  @click="exportBatch('status')">批量导出状态</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="downloadTemplate" style="width: 110px!important;"  @click="exportBatch('excel')">批量导出表格</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" @click="declareRemind">申报提醒</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" @click="approvalRemind">审批提醒</el-button>
          </el-form-item>
          
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="historyTable"
          :edit-config="{trigger: 'manual', mode: 'row'}"
          :merge-cells="mergeCells"
          @cell-click="expandRow"
          @cell-dblclick="dbClickGoDetail"
        >
          <vxe-table-column type="checkbox" width="50" align="center"></vxe-table-column>
          <vxe-table-column field="rowNumber" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="wkNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="wkName" title="姓名" width="120">
            <template #default="{row}">
              <span>{{ row.wkName }}</span>
              <el-tooltip v-if="row.isTemporaryWkNo" class="temporary-tip" effect="dark" content="挂职" placement="top" :popper-options="{removeOnDestroy: true}">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column field="year" title="年份" width="60"></vxe-table-column>
          <vxe-table-column field="superior" min-width="160" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="360" ></vxe-table-column>
          <vxe-table-column field="commitDate" title="提交时间" width="100">
            <template #edit="{ row }">
              <el-date-picker v-model="row.commitDate" type="date" value-format="yyyy/MM/dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{row.commitDate ? new Date(row.commitDate).toLocaleDateString() : ''}}</template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="120">
            <template #default="{ row }">
              <el-tag v-if="row.status === 10" type="close" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === -1" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="approveReason" title="审批意见" min-width="200">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.approveReason || '无' }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="80">
            <template #default="scope">
              <el-tooltip v-if="scope.row.isMultiple" class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='toDetail({row: scope.row})'></i>
              </el-tooltip>
              <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                <i class='icon-close delete' @click.stop='deleteTip(scope.row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <vxe-pager
          background
          :current-page.sync="page.pageIndex"
          :page-size.sync="page.pageSize"
          :total="total"
          height="100%"
          @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p style="text-align: center;">此操作会删除对应的工作项</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="commonDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :title="dialogContent.title" :param="commonParams" :exportType="exportType"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  components: {
    selecter: () => import('@/component/global/customerSelect'),
    DeclareRemind: () => import('./DeclareRemind.vue'),
    ApprovalRemind: () => import('./ApprovalRemind.vue'),
    BatchExport: () => import('./BatchExport.vue'),
    NotJoin: () => import('./NotJoin.vue'),
  },
  name: 'ResponseManage',
  data() {
    return {
      statusList: [],
      searchParam: {
        year: null,
        reWkNo: '',
        status: undefined,
        superiorNo: '',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      that: this,
      expandedData: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      depList: [],
      department: '',
      departmentNo: '',

      mergeCells: [],
      statusMap: {},
      dialogContent: {},

      commonParams: {},
      exportType: '',
      showDelTip: false,
    };
  },
  computed: {},
  created() {
    this.searchParam.year = new Date().getFullYear().toString();
    this.getStatus();
  },
  mounted() {
    this.getDep();
  },
  activated() {
    this.getList();
  },
  methods: {
    getStatus() {
      return this.$ajax.get(this.$api.common.getDict, { ItemType: 'ResponseStatus' }).then((res) => {
        let rows = res.data.rows || [];
        this.statusMap = {};
        this.statusList = [];
        rows.forEach(item => {
          this.statusList.push({
            itemValue: item.itemValue,
            itemDesc: item.itemDesc,
          });
          this.statusMap[item.itemValue] = item.itemDesc;
        })
      });
    },
    expandRow({ rowIndex }) {
      this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.$refs.historyTable.updateData(this.tableData);
    },
    getList(page) {
      if (page) {
        this.page.pageIndex = page;
      }
      const queryWhere = _.cloneDeep(this.searchParam);
      const pageParam = { pageIndex: this.page.pageIndex, pageSize: this.page.pageSize, status: this.searchParam.status || undefined };
      let param = Object.assign({departmentNo: this.departmentNo}, queryWhere, pageParam);
      this.$ajax.post(this.$api.responsWork.manage.list, param).then((res) => {
        const rows = res.data.result || [];
        rows.forEach(val => {
          val.expandRowFlag = false;
        })
        this.handleTableData(rows);
        this.total = res.data.total;
      });
    },
    handleTableData(rows) {
      let tableData = [];
      let mergeCells = [];
      let rowIndex = 0;
      let yearRowIndex = 0;

      rows.forEach((item, index) => {
        let childRows = item.responseInfos || [];
        // 统计每年的数量
        let yearObj = {};
        if (childRows.length === 0) {
          childRows = [item];
        }
        let years = [];
        childRows.sort((a, b) => b.year - a.year)
        childRows.forEach(childItem => {
          let itemYear = childItem['year'];
          if (yearObj[itemYear]) {
            yearObj[itemYear]++
          } else {
            yearObj[itemYear] = 1;
          }
          if (!years.includes(itemYear)) {
            years.push(itemYear);
          }
          tableData.push({
            ...childItem,
            isMultiple: item.responseInfos.length > 0,
            isTemporaryWkNo: item.isTemporaryWkNo,
            rowNumber: (this.page.pageIndex - 1) * this.page.pageSize + index + 1
          });
        })
        
        const length = childRows.length;
        mergeCells.push(
          ...[
            {row: rowIndex, col: 0, rowspan: length, colspan: 1},
            {row: rowIndex, col: 1, rowspan: length, colspan: 1},
            {row: rowIndex, col: 2, rowspan: length, colspan: 1},
            {row: rowIndex, col: 3, rowspan: length, colspan: 1},
          ]
        )
        rowIndex += childRows.length;

        // 年份列合并
        years.forEach(y => {
          mergeCells.push(
            {row: yearRowIndex, col: 4, rowspan: yearObj[y], colspan: 1},
          )
          yearRowIndex += yearObj[y];
        });
      });
      this.tableData = tableData;
      this.mergeCells = mergeCells;
    },
    async getDep() {
      await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then((res) => {
        this.depList = res.data || [];
        this.depList.forEach((v) => {
          const objClone = {};
          (objClone.id = v.id), (objClone.code = v.code), (objClone.label = v.displayName);
          if (v.parentId === null) {
            this.expandedData.push(v.id);
            objClone.children = this.depList.filter((t) => t.parentId === v.id);
            this.generateMenu(objClone.children);
            this.treeData.push(objClone);
          }
        });
      });
    },
    generateMenu(chs) {
      chs.forEach((v) => {
        v.label = v.displayName;
        v.children = this.depList.filter((t) => t.parentId === v.id);
        this.generateMenu(v.children);
      });
    },
    handleCheckChange(){
      this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
      let code = [] , deptNmae = [];
      this.selectNode.forEach(t => {
        code.push(t.code);
        deptNmae.push(t.label);
      });
      this.departmentNo = code.join(",");
      this.department = deptNmae.join(",");
    },
    getSimpleCheckedNodes(store) {
      const checkedNodes = [];
      const traverse = function(node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach(child => {
          if (child.checked) {
            checkedNodes.push(child.data);
          }
          if (child.indeterminate) {
            traverse(child);
          }
        });
      };
      traverse(store)
      return checkedNodes;
    },
    getChildrenMenu(depData = []) {
      let depTree = [];
      depData.forEach((t) => {
        if (t.label.indexOf(this.department) != -1) {
          depTree.push(t);
        } else {
          if (t.children && t.children.length) {
            t.children = this.getChildrenMenu(t.children);
            if (t.children && t.children.length) {
              depTree.push(t);
            }
          }
        }
      });
      return (this.treeData = depTree);
    },
    handledHide() {
      this.$nextTick(() => {
        if (!this.$refs.tree.getCheckedKeys().length) {
          this.department = '';
        }
      });
    },
    handlePageChange({ currentPage }) {
      this.getList(currentPage);
    },
    // 双击跳转详情页，合并行不能双击跳转
    dbClickGoDetail({row, columnIndex}) {
      if (columnIndex < 5) return false;
      this.toDetail({row});
    },
    toDetail({row}) {
      this.$router.push({
        path: '/response/manage/detail',
        query: {
          id: row.id,
          editStatus: 'edit',
          isTemporaryWkNo: row.isTemporaryWkNo ? '1' : '0',
        },
      });
    },
    showNotJoin() {
      this.dialogContent = {
        title: '不参与维护',
        componentName: 'NotJoin',
        width: '810px'
      }
      this.$refs.commonDialog.show();
    },
    exportBatch(type) {
      let title = '批量导出';
      this.exportType = type;
      if (type === 'status') {
        title = '批量导出状态'
      } else if (type === 'excel') {
        title = '批量导出表格'
      }
      this.commonParams = {
        ...this.searchParam,
        departmentNo: this.departmentNo
      };
      this.dialogContent = {
        title,
        componentName: 'BatchExport',
        width: '350px'
      }
      this.$refs.commonDialog.show();
    },
    declareRemind() {
      this.commonParams = {
        ...this.page,
        ...this.searchParam,
        departmentNo: this.departmentNo
      };
      this.dialogContent = {
        title: '提醒人员确认',
        componentName: 'DeclareRemind',
        width: '720px'
      }
      this.$refs.commonDialog.show()
    },
    approvalRemind() {
      this.commonParams = {
        ...this.page,
        ...this.searchParam,
        departmentNo: this.departmentNo
      };
      this.dialogContent = {
        title: '提醒人员确认',
        componentName: 'ApprovalRemind',
        width: '720px'
      }
      this.$refs.commonDialog.show()
    },
    deleteTip(row) {
      this.showDelTip = true;
      this.delRow = row;
    },
    del() {
      if (this.delRow) {
        this.$ajax.get(this.$api.responsWork.manage.deleteResponse, {id: this.delRow.id}).then(() => {
          this.$message.success('删除成功');
          this.getList(1);
        }).finally(() => {
          this.showDelTip = false;
        });
      }
    },
  },
  watch: {
    department: {
      handler(val) {
        if (!val) {
          this.departmentNo = '';
          this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped lang="scss">
.response-manage {
  height: 100%;
  .search {
    .el-date-editor--daterange {
      width: 360px;
      border-radius: 10px;
    }
  }
  .atb-content-bg {
    margin-top: 0px;
    padding: 20px;
    flex: 1;
  }
  .temporary-tip {
    color: #777;
    margin-left: 4px;
    transform: translateY(1px);
  }
  ::v-deep .el-tag {
    padding: 0 8px;
    width: auto;
  }
  ::v-deep .el-dialog__body {
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
    p {
      color: $--color-text-regular;
    }
  }
  .plan_table {
    padding: 0 5px;
  }
  .el-link--danger {
    cursor: auto;
  }
  .el-button.is-disabled, .el-button.is-disabled:hover, .el-button.is-disabled:focus {
    background-color: #f2f2f2!important;
    border-color: #ebeef5!important;
    color: #c0c4cc;
  }
}
.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}
.declare-dep {
  height: 350px;
  width: 350px;
  overflow: auto;
}
</style>
